import { RichText } from 'prismic-reactjs';
import { Item, StageKey } from './processStage.types';
import { ProcessStage } from './ProcessStage';

type Props = {
  items: Item[];
  stageKey: StageKey;
};

export const ProcessStages = ({ items, stageKey }: Props) => {
  return (
    <div
      className={`our-develop-process__stages our-develop-process__stages ${stageKey}`}
    >
      {items.map((item, index: number) => (
        <ProcessStage
          index={index}
          position={item.position}
          key={RichText.asText(item.title)}
          title={RichText.asText(item.title)}
          image={item.image}
          stageDescription={RichText.asText(item.description)}
          stageKey={stageKey}
        />
      ))}
    </div>
  );
};
